
    export enum CalendarEventType {
        Unknown = 0,
        Meeting = 1,
        Holiday = 2,
        TimeOff = 3
      }
      
      export const CalendarEventTypeMapping: Record<CalendarEventType, string> = {
        [CalendarEventType.Unknown]: 'Unknown',
        [CalendarEventType.Meeting]: 'Meeting',
        [CalendarEventType.Holiday]: 'Holiday',
        [CalendarEventType.TimeOff]: 'TimeOff'
      };